import React, { ReactNode } from 'react';

import { GADataType } from '../../../../types';
import { TeamAvatarLinkTeam } from './TeamAvatarLink.types';

import { TeamAvatar } from '../TeamAvatar';
import { TeamLink } from '../TeamLink';

interface TeamAvatarLinkDefaultProps {
  newLabel?: ReactNode;
  team: TeamAvatarLinkTeam;
  withLibraryLink?: boolean;
}

interface TeamAvatarLinkWithClassNameProps {
  className: string;
  avatarType?: never;
  width?: number;
  height?: number;
}

interface TeamAvatarLinkWithAvatarTypeProps {
  className?: never;
  avatarType: 'main' | 'xl' | 'xs' | 's';
  width?: number;
  height?: number;
}

type TeamAvatarLinkProps = TeamAvatarLinkDefaultProps &
  (TeamAvatarLinkWithClassNameProps | TeamAvatarLinkWithAvatarTypeProps) &
  GADataType;

function TeamAvatarLink({
  avatarType,
  className,
  dataGa,
  height,
  newLabel,
  team,
  width,
  withLibraryLink
}: TeamAvatarLinkProps) {
  if (!team) {
    return null;
  }

  return (
    <TeamLink
      className="h-fit w-fit"
      dataGa={dataGa}
      team={team}
      withLibraryLink={withLibraryLink}
    >
      <TeamAvatar
        team={team}
        type={avatarType}
        className={className}
        width={width}
        height={height}
      />
      {newLabel}
    </TeamLink>
  );
}

export default TeamAvatarLink;
